import { PropertiesStore } from '@hortplus/properties-react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import InsectGroupSelect from '../../InsectGroupSelect';
import HotTrapMap from '../../maps/HotTrapMap';
import { useStores } from '../../stores/useStores';

const HotTrap = (props) => {
  const { traplogStore } = useStores();
  const [hotTrapStatuses, setHotTrapStatuses] = useState();
  const [loading, setLoading] = useState(false);

  const propertiesStore = props.propertiesStore;
  const selectedPropertyId = propertiesStore.selectedPropertyId;
  const selectedInsectGroupId = traplogStore.selectedInsectGroupId;

  useEffect(() => {
    let ignore = false;
    if (selectedPropertyId && selectedInsectGroupId) {
      setLoading(true);
      fetch(
        `${process.env.REACT_APP_TRAPLOG_API_URL}api/properties/${selectedPropertyId}/traps-thresholds?insect_group_id=${selectedInsectGroupId}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${props.bearerToken}`,
            SeasonalDatabase: props.selectedDatabase
          }
        }
      )
        .then((res) => {
          if (res.ok) return res.json();
          else if (res.status === 401) props.refreshBearerToken();
          else throw Error(res.statusText);
        })
        .then((data) => {
          if (data) {
            if (!ignore) setHotTrapStatuses(data);
          }
        })
        .catch((err) => {
          if (process.env.NODE_ENV === 'development') console.error(err);
          if (!ignore) setHotTrapStatuses([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    return () => {
      ignore = true;
    };
  }, [selectedPropertyId, selectedInsectGroupId]);

  return (
    <Container>
      <Row className='mb-4 justify-content-center'>
        <Col
          xs={3}
          sm={2}
          className='d-flex align-items-center justify-content-end pr-0 font-weight-bold'
        >
          Insect:
        </Col>
        <Col xs={9} md={8} lg={6}>
          <InsectGroupSelect
            selectedDatabase={props.selectedDatabase}
            bearerToken={props.bearerToken}
            refreshBearerToken={props.refreshBearerToken}
            customInsects={['CM', 'CM SIT', 'LBAM', 'LBAM SIT']}
          />
        </Col>
        <Col
          xs={0}
          sm={1}
          className='d-flex align-items-center justify-content-end pl-0 font-weight-bold'
          style={{ visibility: 'hidden' }}
        >
          Insect:
        </Col>
      </Row>
      {traplogStore.selectedInsectGroupId === null ? null : props
          .propertiesStore.loading ||
        traplogStore.loadingInsectGroups ||
        traplogStore.loadingTrappingZones ||
        traplogStore.loadingTrappingResults ||
        loading ? (
        <Col className='text-center mt-3 mb-3'>
          <Spinner variant='primary' animation='border' />
        </Col>
      ) : (
        <Row>
          <Col>
            <Row className='w-100 no-gutters'>
              <Col style={{ height: '400px' }}>
                <HotTrapMap
                  propertiesStore={props.propertiesStore}
                  onClick={(id) => {
                    traplogStore.setSelectedTrappingZoneId(id);
                  }}
                  hotTrapStatuses={hotTrapStatuses}
                />
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col className='text-center'>
                <Alert variant='light'>
                  <p className='mb-0'>
                    The hot trap map uses the season monitoring data to help
                    identify traps that are catching more moths than the others
                    on the property. These traps are marked red as hot traps.
                  </p>
                </Alert>
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col className='text-center '>
                <Button as='a' href='/pest-disease/trapping-overview'>
                  View Monitoring
                </Button>
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col className='text-center'>
                <Button
                  as='a'
                  href={`/pest-disease/seasonal-trapping-report?property_id=${selectedPropertyId}`}
                >
                  Season Overview
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Container>
  );
};

HotTrap.propTypes = {
  selectedDatabase: PropTypes.string,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  propertiesStore: PropTypes.instanceOf(PropertiesStore).isRequired
};

export default observer(HotTrap);
